export const focusPages = [
  { label: 'Rygsmerter', href: '/rygsmerter' },
  { label: 'Akupunktur', href: '/akupunktur' },
  { label: 'KOL', href: '/kol' },
  { label: 'Sportsskader', href: '/sportsskader' },
]

export const mainMenu = [
  { label: 'Forside', href: '/' },
  {
    label: 'Aktuelt',
    children: [
      { label: 'Nyheder', href: '/nyheder' },
      { label: 'Anbefalet læsning', href: '/anbefalet-laesning' },
      { label: 'Gode råd', href: '/gode-raad' },
    ],
  },
  {
    label: 'Om os',
    children: [
      { label: 'Klinikkens baggrund', href: '/klinikkens-baggrund' },
      { label: 'Klinikkens historie', href: '/klinikkens-historie' },
      { label: 'Jørgens baggrund', href: '/joergens-baggrund' },
      { label: 'Lars’ baggrund', href: '/lars-baggrund' },
    ],
  },
  {
    label: 'Behandlingsmetoder',
    children: [
      { label: 'Traditionel Kinesisk medicin (T.K.M.)', href: '/behandlingsmetoder/traditionel-kinesisk-medicin-t-k-m' },
      { label: 'Klassisk Kinesisk akupunktur nær Århus', href: '/behandlingsmetoder/akupunktur' },
      { label: 'Kinesisk urtemedicin', href: '/behandlingsmetoder/kinesisk-urtemedicin' },
      { label: 'Chi-Kung (energitræning)', href: '/behandlingsmetoder/chi-kung-energitraening' },
      { label: 'Chi-Kung - Holdtræning', href: '/behandlingsmetoder/chi-kung-workshop' },
      { label: 'Tai Chi Chuan', href: '/behandlingsmetoder/tai-chi-chuan' },
      { label: 'Øreakupunktur', href: '/behandlingsmetoder/oereakupunktur' },
      { label: 'Posturologi', href: '/behandlingsmetoder/posturologi' },
      { label: 'Laserterapi', href: '/behandlingsmetoder/laserterapi' },
      { label: 'Magnetfelt Terapi', href: '/behandlingsmetoder/magnetfelt-terapi' },
      { label: 'TENS', href: '/behandlingsmetoder/tens' },
      { label: 'E.F.T. – Banke Akupunktur', href: '/behandlingsmetoder/e-f-t-banke-akupunktur' },
      { label: 'Vægttab på den nemme måde', href: '/behandlingsmetoder/vaegttab-paa-den-nemme-maade' },
    ],
  },
  {
    label: 'Sygdomme / lidelser',
    href: '/sygdomme-lidelser',
    children: [
      { label: 'Oversigt', href: '/sygdomme-lidelser' },
      { label: 'WHO anbefaler akupunktur', href: '/sygdomme-lidelser/who-anbefaler-akupunktur' },
      { label: 'Reaktioner', href: '/sygdomme-lidelser/reaktioner' },
      { label: 'Behandlingsforløb', href: '/sygdomme-lidelser/behandlingsforloeb' },
    ],
  },
  { label: 'Patienthistorier', href: '/patienthistorier' },
  { label: 'Priser', href: '/priser' },
  { label: 'Kontakt', href: '/kontakt' },
]

export const treatmentFocusMap = {
  rygsmerter: ['rygsmerter'],
  akupunktur: ['akupunktur'],
  kol: ['kol'],
  sportsskader: ['sportsskader'],
  diskusprolaps: ['rygsmerter'],
  'iskias-smerter': ['rygsmerter'],
  'piskesmaeld-whiplash': ['rygsmerter'],
  'knae-smerter': ['sportsskader'],
  behandlingsforloeb: ['rygsmerter'],
}

export const featuredCollectionSlugs = [
  'behandlinger',
  'akupunktur',
  'rygsmerter',
  'kol',
  'sportsskader',
  'behandlingsforloeb',
  'diskusprolaps',
  'iskias-smerter',
  'piskesmaeld-whiplash',
  'knae-smerter',
]
